
const GalleryHero = () => {
  return (
    <section className="relative h-[300px] sm:h-[350px] md:h-[400px] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `linear-gradient(rgba(30, 64, 175, 0.85), rgba(37, 99, 235, 0.85)), url('https://readdy.ai/api/search-image?query=modern%20construction%20site%20with%20completed%20luxury%20residential%20buildings%20and%20commercial%20projects%2C%20professional%20architecture%20photography%2C%20clean%20blue%20sky%20background%2C%20wide%20angle%20view%20showing%20multiple%20finished%20buildings%2C%20contemporary%20design&width=1920&height=400&seq=gallery-hero-bg&orientation=landscape')`
        }}
      />
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6">Galerie de Nos Projets</h1>
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">Découvrez nos réalisations exceptionnelles en construction et rénovation</p>
      </div>
    </section>
  );
};

export default GalleryHero;
